import { Injectable, inject } from '@angular/core';
import { ApiService } from '@app/gateway';
import { CertificateFactory, CertificateModel } from '../models';

@Injectable({ providedIn: 'root' })
export class CertificatesService {
  private readonly apiService = inject(ApiService);

  public async getCertificates(): Promise<CertificateModel[]> {
    try {
      const path: string = `${CertificateFactory.getPath()}`;
      const certificates: CertificateModel[] = await this.apiService.get<CertificateModel[]>({ path });
      return certificates;
    } catch (e: any) {
      throw new Error(e.message, { cause: e });
    }
  }
}
